// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthNav_wrapper__2_oIW","navLink":"AuthNav_navLink__19lyn","activeNavLink":"AuthNav_activeNavLink__GR1Qy"};